import BaseQuery from "@/stateManagement/BaseQuery";
import { injectable } from "tsyringe";

import NudgesStore, { NudgesState } from "../stores/NudgesStore";

@injectable()
class NudgesQuery extends BaseQuery<NudgesState> {
    constructor(protected store: NudgesStore) {
        super(store);
    }

    nudges$ = this.select((state) => state.nudges);
    status$ = this.selectStatus();
}

export default NudgesQuery;
